module.exports = __webpack_public_path__ + "static/img/guowei_top.4b791b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/guowei_top.png
// module id = JA1b
// module chunks = 4